import { render } from "./OrderItemList.vue?vue&type=template&id=8cbe2aba&ts=true"
import script from "./OrderItemList.vue?vue&type=script&lang=ts"
export * from "./OrderItemList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__